import React from "react";
import packageJson from "../../package.json";
import { ENV_NAME } from "../client-config.js";

import withWidth, { isWidthDown } from "@material-ui/core/withWidth";
import Box from "@material-ui/core/Box";

const Version = (props) => {
  const version = packageJson.version;
  if (isWidthDown("sm", props.width) && props.shortDisplay) {
    return (
      <Box className="text-38 text-center" style={{ fontSize: "0.750em" }}>
        {ENV_NAME}
        <br />
        {version}
      </Box>
    );
  }

  if (props.shortDisplay) {
    return (
      <Box className="text-38" style={{ fontSize: "0.750em" }}>
        {ENV_NAME}
        <br />
        {version}
        <br />({process.env.REACT_APP_COMMIT_NUMBER})
      </Box>
    );
  }

  return (
    <Box className="text-54" style={{ textAlign: "center", fontSize: "14px" }}>
      {ENV_NAME} - {version} ({process.env.REACT_APP_COMMIT_NUMBER})
    </Box>
  );
};

export default withWidth()(Version);
